<template>
  <div
    v-if="files.length !== 0"
    class="file-list"
  >
    {{ $t('okr.review.attachmentLabel') }}
    <a-tag
      v-for="file in files"
      :key="file.id"
    >
      <a-space class="space-flex">
        <a
          :href="file.url || getDownloadUrl(file.id)"
          target="_blank"
        >
          {{ file.name }}
        </a>
        <IconFont
          v-if="canEdit"
          type="iconguanbi-2"
          :style="{ display: 'block' }"
          @click="$emit('file-deleted', file.id)"
        />
      </a-space>
    </a-tag>
  </div>
</template>

<script>
import { getDownloadUrl } from '@/utils/upload'

export default {
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    files: {
      type: Array,
      required: true
    }
  },
  emits: [
    'file-deleted'
  ],
  setup () {
    return {
      getDownloadUrl
    }
  }
}
</script>

<style lang="less" scoped>
.file-list {
  font-size: 12px;
  line-height: 1.8;
}
</style>
